// Event should be descriptive enough to understand action at a glance without additional context
// Amplitude has a 2000 unique event limit

export enum Event {
  Next = 'next',
  VerifyCardholderEmailVerification = 'verify-cardholder-email-verification',
  VerifyCardholderConfirmation = 'verify-cardholder-confirmation',

  // Credit Application
  IdentiAgreementFetchError = 'identi-agreement-fetch-error',
  IdentiAgreementSigned = 'identi-agreement-signed',
  IdentiAgreementSigningError = 'identi-agreement-signing-error',
  RhAccountTermsAndConditionsAccepted = 'rh-account-terms-and-conditions-accepted',
  RhApplicationTermsAndConditionsAccepted = 'rh-application-terms-and-conditions-accepted',
  RhWebCreditApplicationNewUserSheriffSignup = 'rh-web-credit-application-new-user-sheriff-signup',
  RhWebCreditApplicationExistingUserLogin = 'rh-web-credit-application-existing-user-login',
  RhApplicationEligibilityRestricted = 'rh-application-eligibility-restricted',
  RhWebCreditApplicationErrorModalShown = 'rh-web-credit-application-error-modal-shown',

  // Referrals
  ReferralCodeApplied = 'referral-code-applied',
  ReferralCodeApplicationError = 'referral-code-application-error',
}
